export default "__VITE_ASSET__98Mql9Hu__"